import {
    LOAD_SHIPMENT_CONTRACT,
    CREATE_SHIPMENT_CONTRACT,
    UPDATE_SHIPMENT_CONTRACT,
    LOAD_SHIPMENT_CONTRACT_DETAIL,
    REMOVE_LISTS,
} from './actions'

const initialState = {
    lists_for_edit: null,
    Lists: [],
    total: 1,
    loading: false,
    draw: -1,
    check: true,
}

export default (state = initialState, action) => {
    switch (action.type) {

        case REMOVE_LISTS:
            return initialState

        case LOAD_SHIPMENT_CONTRACT.REQUEST:
            const { loading } = action.payload.data
            return {
                ...state,
                loading: loading,
            }

        case LOAD_SHIPMENT_CONTRACT.SUCCESS:
            const { page, pageSize } = action.payload
                for (let i = 0; i < action.payload.lists.data.length; i++) {
                  action.payload.lists.data[i].rowNumber = i + 1
                  if (page > 1)
                    action.payload.lists.data[i].rowNumber =
                      action.payload.lists.data[i].rowNumber + (page - 1) * pageSize
                }
            return {
                ...state,
                Lists: action.payload.lists.data,
                total:
                    action.payload.lists.total - 1 <= 0
                      ? 1
                      : action.payload.lists.total <= 0
                      ? 1
                      : action.payload.lists.total,
                loading: false,
                draw: Math.floor(Math.random() * 999 + 1),
            }

        case CREATE_SHIPMENT_CONTRACT.REQUEST:
            return {
                ...state,
                loading: true,
            }
        case CREATE_SHIPMENT_CONTRACT.SUCCESS:
            return {
                ...state,
                loading: false,
            }

        case UPDATE_SHIPMENT_CONTRACT.REQUEST:
            return {
                ...state,
                loading: true,
            }
        case UPDATE_SHIPMENT_CONTRACT.SUCCESS:
            return {
                ...state,
                loading: false,
            }

        case LOAD_SHIPMENT_CONTRACT_DETAIL.REQUEST:
            return {
                ...state,
                loading: true,
                check: true,
            }
          
        case LOAD_SHIPMENT_CONTRACT_DETAIL.SUCCESS:
            return {
                ...state,
                lists_for_edit: action.payload.listsEdit.data,
                check: false,
                loading: false,
            }
            
        default:
            return state
    }
}